var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "the-section",
    {
      staticClass: "references",
      attrs: { legend: "Our trophies", id: "trophies" },
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v("We join forces with "),
          _c("strong", [_vm._v("big guns")]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid" },
        _vm._l(_vm.$store.state.references, function (reference) {
          return _c(
            "div",
            {
              key: reference.id,
              ref: "reference",
              refInFor: true,
              staticClass: "reference",
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.getUrl(reference.logo.id),
                  title: reference.label,
                },
              }),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }